module.exports = __webpack_public_path__ + "img/d6.c3f676a5.png";